import { gsap } from 'gsap';

// Градиент EC6328 → E4B064 → 65C5E6
const color12 = gsap.utils.interpolate("#EC6328", "#E4B064");
const color23 = gsap.utils.interpolate("#E4B064", "#65C5E6");

const getGradientColor = (progress) => {
  // первая половина: 0 → 0.5
  if (progress <= 0.5) {
    return color12(progress / 0.5);
  }
  // вторая половина: 0.5 → 1
  return color23((progress - 0.5) / 0.5);
};

if (document.querySelector('[data-splitting-title]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-title]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-words]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-words]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'words',
    });
  });
}

if (document.querySelector('[data-splitting-chars]')) {
  const targets = document.querySelectorAll('[data-splitting-chars]');

  targets.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });

    if (item.classList.contains('cl-gradient-js')) {
      const chars = item.querySelectorAll('.char');
      const total = chars.length - 1;

      gsap.set(chars, {
        color: (index) => getGradientColor(index / total),
      });

      item.classList.add('is-init-cl-gradient-js');

      return;
    }

    const innerGradientBlocks = item.querySelectorAll('.cl-gradient-js');

    if (innerGradientBlocks.length > 0) {
      innerGradientBlocks.forEach((block) => {
        const blockChars = block.querySelectorAll('.char');
        const total = blockChars.length - 1;

        gsap.set(blockChars, {
          color: (index) => getGradientColor(index / total),
        });

        block.classList.add('is-init-cl-gradient-js');
      });
    }
  });
}

/*if (document.querySelector('[data-splitting-chars]')) {
  const splittingArr = document.querySelectorAll('[data-splitting-chars]');
  splittingArr.forEach((item) => {
    Splitting({
      target: item,
      by: 'chars',
    });
  });
  gsap.set(splitText.chars, {
    color: (index, target, targets) => color(index / (targets.length - 1))
  });
}*/

/*const variableFontAnimationElsArr = document.querySelectorAll('[data-variable-font-animation]');
variableFontAnimationElsArr.forEach((variableFontAnimationEl) => {
  const timeline = gsap.timeline({repeat: -1});
  const chars = variableFontAnimationEl.querySelectorAll(".char");

  // gsap.set(".one", {color: "#3498DB"});
  // gsap.set(".two", {color: "#E74C3C"});
  // gsap.set(".three", {color: "#F1C40F"});
  // gsap.set(".four", {color: "#3498DB"});
  // gsap.set(".five", {color: "#27AE60"});
  // gsap.set(".six", {color: "#E74C3C"});

  timeline.from(chars, {opacity: 0, scale: 0, ease: "sine", delay: 0.25})
      .to(".char", {
        opacity: 1,
        "--font-weight": 700,
        duration: 1.2,
        ease: "sine.inOut",
        stagger: {
          yoyo: true,
          each: 0.1,
          repeat: -1
        }
      }, 1);
})*/

